<div class="dashboard-stats">
  <div class="stats-toolbar">
    <div>
      <p class="eyebrow">Live overview</p>
      <h2>{{ isPassenger() ? 'Trip activity' : 'Operational snapshot' }}</h2>
    </div>
    <div class="refresh-state" [class.loading]="isLoading">
      <i class="material-icons">{{ isLoading ? 'sync' : 'cloud_done' }}</i>
      <span>{{ isLoading ? 'Loading API data' : (lastUpdated ? ('Updated ' + (lastUpdated | date:'shortTime')) : 'Ready') }}</span>
    </div>
  </div>

  <div class="stats-warning" *ngIf="warningMessage">
    <i class="material-icons">info</i>
    <span>{{ warningMessage }}</span>
  </div>

  <div class="stats-grid">
    <div class="stat-card" *ngIf="isPlatformEmployee()">
      <div class="stat-icon admin">
        <i class="material-icons">business</i>
      </div>
      <div class="stat-content">
        <h3>{{ stats.totalOrganisations || 0 }}</h3>
        <p>Organisations</p>
        <span class="stat-change">Fetched from API</span>
      </div>
    </div>

    <div class="stat-card" *ngIf="!isPassenger()">
      <div class="stat-icon vehicles">
        <i class="material-icons">directions_car</i>
      </div>
      <div class="stat-content">
        <h3>{{ stats.totalVehicles || 0 }}</h3>
        <p>Vehicles</p>
        <span class="stat-change positive">{{ stats.trackedVehicles || 0 }} with devices</span>
      </div>
    </div>

    <div class="stat-card" *ngIf="!isPassenger()">
      <div class="stat-icon passengers">
        <i class="material-icons">groups</i>
      </div>
      <div class="stat-content">
        <h3>{{ stats.totalPassengers || 0 }}</h3>
        <p>Passengers</p>
        <span class="stat-change">Registered users</span>
      </div>
    </div>

    <div class="stat-card" *ngIf="isOperator()">
      <div class="stat-icon active">
        <i class="material-icons">directions_bus</i>
      </div>
      <div class="stat-content">
        <h3>{{ stats.activeRoutes || 0 }}</h3>
        <p>Active Routes</p>
        <span class="stat-change">{{ stats.activeTrips || 0 }} active trips</span>
      </div>
    </div>

    <div class="stat-card" *ngIf="isOperator()">
      <div class="stat-icon trips">
        <i class="material-icons">schedule</i>
      </div>
      <div class="stat-content">
        <h3>{{ stats.todayTrips || 0 }}</h3>
        <p>Trips Today</p>
        <span class="stat-change">Starting today</span>
      </div>
    </div>

    <div class="stat-card" *ngIf="showBookingMetrics()">
      <div class="stat-icon bookings">
        <i class="material-icons">book_online</i>
      </div>
      <div class="stat-content">
        <h3>{{ stats.todayBookings || 0 }}</h3>
        <p>Today's Bookings</p>
        <span class="stat-change">Created today</span>
      </div>
    </div>

    <div class="stat-card" *ngIf="showBookingMetrics()">
      <div class="stat-icon revenue">
        <i class="material-icons">payments</i>
      </div>
      <div class="stat-content">
        <h3>R {{ (stats.monthlyRevenue || stats.totalRevenue || 0) | number }}</h3>
        <p>{{ isPlatformEmployee() ? 'Total' : 'Monthly' }} Revenue</p>
        <span class="stat-change positive">From bookings</span>
      </div>
    </div>

    <!-- <div class="stat-card" *ngIf="isPassenger()">
      <div class="stat-icon upcoming">
        <i class="material-icons">upcoming</i>
      </div>
      <div class="stat-content">
        <h3>{{ stats.upcomingTrips || 0 }}</h3>
        <p>Available Upcoming Trips</p>
        <span class="stat-change">From trip schedule</span>
      </div>
    </div>

    <div class="stat-card" *ngIf="isPassenger()">
      <div class="stat-icon past">
        <i class="material-icons">history</i>
      </div>
      <div class="stat-content">
        <h3>{{ stats.pastTrips || 0 }}</h3>
        <p>Past Trips</p>
        <span class="stat-change">Historical schedule</span>
      </div>
    </div> -->
  </div>
</div>
